import { render } from "./CurrencyAmountMapInput.vue?vue&type=template&id=22788adb&scoped=true&ts=true"
import script from "./CurrencyAmountMapInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyAmountMapInput.vue?vue&type=script&lang=ts"

import "./CurrencyAmountMapInput.vue?vue&type=style&index=0&id=22788adb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22788adb"]])

export default __exports__